export const HEADER_TYPE = {
  MAIN: "main",
  SETTINGS: "settings",
  ACCOUNT: "account",
  STATS: "stats"
}
